/**
 * Icon/typed.ts
 * desc: typed view of the still-JS icon set for components written in TypeScript
 * note: delete when the icons convert — the cast masks their real signatures (an unconverted JS component infers
 *       every destructured prop as required). Add icons to the export list as TypeScript consumers need them.
 */
import type { ComponentType } from 'react';
import * as IconsUntyped from './index';
import type { IconProps } from './IconButton/typed';

export type Icon = ComponentType<IconProps>;

const icons = IconsUntyped as unknown as Record<keyof typeof IconsUntyped, Icon>;

export const {
    AnalyticsIcon,
    BookIcon,
    ChevronDownIcon,
    ChevronRightIcon,
    ChevronUpIcon,
    CodeIcon,
    ComponentsIcon,
    DeleteIcon,
    DiscoverIcon,
    DocumentIcon,
    DownloadIcon,
    FolderIcon,
    GridIcon,
    HomeIcon,
    JourneyIcon,
    LinkIcon,
    ListIcon,
    OpenIcon,
    PhotoIcon,
    PinIcon,
    ReceiptIcon,
    ReviewsIcon,
    SettingsIcon,
    UnpinIcon,
} = icons;
